import React, { useEffect } from 'react'
import WtnHiLo from './PlayerStatsHighsLows'
import MatchActivity from './MatchActivity'
import { PlayerStats as PlayerStatsType } from 'types/global'
import { connect } from 'react-redux'
import { getPlayerStats } from 'actions/profile-actions'
import memo from 'memoize-one'
import { AppState } from 'redux/reducers'
import InfoBoxContainer from 'components/generic/InfoBoxContainer'
import InfoBoxesWrapper from 'components/generic/InfoBoxesWrapper'

interface Props {
  stats: PlayerStatsType
  getPlayerStats: () => any
}

const PlayerStats: React.FC<Props> = ({ getPlayerStats, stats }) => {
  useEffect(() => {
    getPlayerStats()
  }, [getPlayerStats])

  return (
    <InfoBoxesWrapper>
      <InfoBoxContainer>
        <MatchActivity {...stats} />
      </InfoBoxContainer>

      <InfoBoxContainer>
        <WtnHiLo {...stats} />
      </InfoBoxContainer>

    </InfoBoxesWrapper>
  )
}

const mapStateToProps = ({ profile }: AppState) => ({
  stats: profile.playerStats
})

const memoizedDispatch = memo((playerId: string, dispatch) => ({
  getPlayerStats: () => dispatch(getPlayerStats(playerId))
}))

const mapDispatchToProps = (dispatch, { playerId }) => memoizedDispatch(playerId, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PlayerStats)